function ScrollElements() {
    const sectionBgColor = document.querySelectorAll('[data-scrollcolour]')
    const menuColor = document.querySelectorAll('[data-menusc]')
    const sttColor = document.querySelectorAll('[data-sttc]')
    const pageContent = document.querySelector('#page-content')

    if (sectionBgColor) {
        sectionBgColor.forEach((section, index) => {
            const prevColour = index === 0 ? "#FFFFFF" : sectionBgColor[index - 1].dataset.scrollcolour
        
            ScrollTrigger.create({
                trigger: section,
                start: "top center",
                onEnter: () => gsap.to(pageContent, { backgroundColor: section.dataset.scrollcolour}),
                onLeaveBack: () => gsap.to(pageContent, { backgroundColor: prevColour })
            })
        })
    }
    
    if (menuColor) {
        menuColor.forEach((section, index) => {
            const prevColour = index === 0 ? "#FFFFFF" : menuColor[index - 1].dataset.menusc
        
            ScrollTrigger.create({
                trigger: section,
                start: "top 60px",
                onEnter: () => {                
                    document.body.style.setProperty('--menu-color', section.dataset.menusc)
                }, 
                onLeaveBack: () => {
                    document.body.style.setProperty('--menu-color', prevColour)
                }
            })
        })
    }

    if (sttColor) {
        sttColor.forEach((section, index) => {
            const prevColour = index === 0 ? "#FFFFFF" : menuColor[index - 1].dataset.sttc
        
            ScrollTrigger.create({
                trigger: section,
                start: "top 98%",
                onEnter: () => {                
                    document.body.style.setProperty('--stt-color', section.dataset.sttc)
                }, 
                onLeaveBack: () => {
                    document.body.style.setProperty('--stt-color', prevColour)
                }
            })
        })
    }
}

export default ScrollElements